"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { MembraneClient } from '@membranehq/sdk';
import { useRef, useMemo } from 'react';
import { IntegrationAppContext } from './use-integration-app.mjs';

const IntegrationAppProvider = ({
  token,
  fetchToken,
  credentials,
  fetchCredentials,
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  apiUri = null,
  /* FIXME: strictNullCheck temporary fix */
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  uiUri = null,
  children
}) => {
  const fetchTokenRef = useRef(fetchToken);
  fetchTokenRef.current = fetchToken;
  const fetchCredentialsRef = useRef(fetchCredentials);
  fetchCredentialsRef.current = fetchCredentials;
  const client = useMemo(
    () => new MembraneClient({
      token,
      fetchToken: fetchToken ? () => {
        const fn = fetchTokenRef.current;
        if (!fn) throw new Error("fetchToken is no longer available");
        return fn();
      } : void 0,
      credentials,
      fetchCredentials: fetchCredentials ? () => {
        const fn = fetchCredentialsRef.current;
        if (!fn) throw new Error("fetchCredentials is no longer available");
        return fn();
      } : void 0,
      apiUri,
      uiUri
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token, JSON.stringify(credentials), apiUri, uiUri, !!fetchToken, !!fetchCredentials]
  );
  return /* @__PURE__ */ jsx(IntegrationAppContext.Provider, { value: client, children });
};
const MembraneProvider = IntegrationAppProvider;

export { IntegrationAppProvider, MembraneProvider };
